import { render } from "./ProcessingOrders.vue?vue&type=template&id=f2a8d238&scoped=true"
import script from "../js/processing-orders.js?vue&type=script&lang=js&external"
export * from "../js/processing-orders.js?vue&type=script&lang=js&external"

import "./ProcessingOrders.vue?vue&type=style&index=0&id=f2a8d238&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2a8d238"]])

export default __exports__